<template>
  <div>
    <TagSelector mainHeading="" optionName="users" availableOptionsHeading="All Users"
      selectedOptionsHeading="Current Users who prefer this activity" :initial-skills="availableAllUsers"
      v-model:interests="currentPreferedUsers" :onSave="readOnly ? null : handleSaveActivities" :loading="loading"
      :showDefaultMessage="false" :isSaving="submitting" />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";
import TagSelector from "@/components/common/TagSelector.vue";

defineProps({
    readOnly: { type: Boolean, default: false }
});

const store = useStore();
const route = useRoute();
const toast = useToast();

const loading = ref(false);
const submitting = ref(false);

const availableAllUsers = ref([]); // all users
const currentPreferedUsers = ref([]); // preferred users

// ✅ Get IDs from route
const activityId = route.params.activityid;

/**
 * Load preferred & available users for this activity
 */
const loadPreferredUsers = async () => {
  loading.value = true;
  try {
    const data = await store.dispatch("fetchPreferred", activityId);

    const preferred = data?.output?.preferred_users || [];
    const available = data?.output?.available_users || [];

    availableAllUsers.value = available?.map((u) => ({
      id: u.personid,
      name: `${u.firstname} ${u.lastname}`,
      description: u.email || "",
    }));

    currentPreferedUsers.value = preferred?.map((u) => ({
      id: u.personid,
      name: `${u.firstname} ${u.lastname}`,
      description: u.email || "",
    }));
  } catch (error) {
    toast.error("Failed to load preferred users", { position: "top-right" });
    console.error(error);
  } finally {
    loading.value = false;
  }
};

/**
 * Save preferred users for this activity
 */
const handleSaveActivities = async (selected) => {
  submitting.value = true;
  try {
    const userIds = selected.map((x) => String(x.id));
    const result = await store.dispatch("saveUserPreferred", {
      activityid: activityId,
      useridsarray: userIds,
    });
    toast.success(result.message, { position: "top-right" });
    await loadPreferredUsers();
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
};

// ✅ Lifecycle
onMounted(() => {
  loadPreferredUsers();
});
</script>